const isProduction = process.env.ENV_NAME === "production";
export default isProduction;
